export default __webpack_public_path__ + "assets/images/dcc67150e4202e5ac12349ed7decc195.svg";